export const VAR_POSITION_OFFSET_X = '--guideline-offset-x';
export const VAR_POSITION_OFFSET_Y = '--guideline-offset-y';
